import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";
import { fmtDateTime } from "@/lib/format";
import { Megaphone } from "lucide-react";

export default function Alerts() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customer/alerts").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-8" data-testid="customer-alerts-page">
      <PageHeader eyebrow="Inbox" title="Announcements & alerts" description="Launches, offers, and announcements from your developer." />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((a) => (
          <div key={a.id} className="grid-surface p-5 border-l-4 border-l-brand-500" data-testid={`alert-${a.id}`}>
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-2">
                <Megaphone size={16} className="text-brand-500" />
                <StatusBadge value={a.alert_type} label={a.alert_type?.toUpperCase()} />
              </div>
              <div className="text-xs text-stone-500 font-mono">{fmtDateTime(a.created_at)}</div>
            </div>
            <h3 className="font-display text-lg font-bold mt-3">{a.title}</h3>
            <p className="text-sm text-stone-700 mt-1.5">{a.body}</p>
          </div>
        ))}
        {items.length === 0 && (
          <div className="grid-surface border-dashed p-10 text-center overline text-stone-400 col-span-full">
            No alerts yet
          </div>
        )}
      </div>
    </div>
  );
}
